const attrIsTruthy = (attribute) => {
    return attribute !== null && attribute !== undefined && (attribute === true || attribute === 'true' || attribute === 'True');
};
export default attrIsTruthy;